import { NegotiationDetail, NegotiationStatus, NegotiationType } from 'api'
import { Locale, Translation } from 'locale'
import { isNil } from 'lodash'
import React from 'react'
import { TypedCellRendererParams } from 'view/components/datagrid'
import { iconSet } from 'view/components/icons/iconSet'
import { getLiveStatusText } from '../../shared/utils'
import { StatusTimerContainer, StatusContainer } from './NegotiationActionRendererStyles'

export const NegotiationStatusRendererComponent: React.FC<TypedCellRendererParams<NegotiationDetail>> = ({ node: { data } }) => {
  if (isNil(data)) {
    return null
  }

  const negotiation = data.negotiation
  const isAwaiting = negotiation.status === NegotiationStatus.REQUESTED_WITHOUT_PRICE
  const statusText = isAwaiting ? Locale.translate(Translation.TC_AWAITING) : getLiveStatusText(data)
  const shouldShowStatusTimer = negotiation.negotiationType !== NegotiationType.ONE_CANCELS_OTHERS_SUMMARY

  return (
    <StatusTimerContainer data-test-id="status-timer-container">
      {shouldShowStatusTimer && (
        <StatusContainer awaiting={isAwaiting}>
          {isAwaiting && iconSet.timerIcon} {statusText}
        </StatusContainer>
      )}
    </StatusTimerContainer>
  )
}
